// extracted by mini-css-extract-plugin
export var chip = "_9w-0";
export var filterDropdown = "_9w-5";
export var filterItem = "_9w-6";
export var icon = "_9w-1";
export var removeButton = "_9w-3";
export var removeIcon = "_9w-4";
export var separator = "_9w-2";